import { Layer, LayerProps, Source } from 'shared/map-exports';
import { getWatchdutyTileUrl } from 'features/mapping/components/layers/layers.utils';
import { ON_TOP_OF_EVERYTHING_LAYER_ID } from 'features/mapping/styles/constants';

export type RegionFeatureProperties = {
  region_id: number;
  name: string;
};

export const REGIONS_QUERY_LAYER_ID = 'regions-query';
const REGIONS_QUERY_MIN_ZOOM = 8;

// Invisible layer: only exists so regions can be queried via
// queryRenderedFeatures, nothing is meant to render. Fill, because that hit
// tests a region's whole area, including when the viewport is inside it.
const regionsQueryStyle: LayerProps = {
  id: REGIONS_QUERY_LAYER_ID,
  minzoom: REGIONS_QUERY_MIN_ZOOM,
  type: 'fill',
  'source-layer': 'regions',
  paint: {
    'fill-opacity': 0,
  },
};

export const RegionsLayer = (): JSX.Element => {
  return (
    <Source url={getWatchdutyTileUrl('regions')} type="vector">
      <Layer beforeId={ON_TOP_OF_EVERYTHING_LAYER_ID} {...regionsQueryStyle} />
    </Source>
  );
};
